import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { Answer, Question } from '@domains/cej-v2/cej-v2-form/cej-orientation-graph';

@Component({
  selector: 'app-cej-simple-choice-question',
  templateUrl: './cej-simple-choice-question.component.html',
  styleUrls: ['./cej-simple-choice-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejSimpleChoiceQuestionComponent {
  @Input() question!: Question;
  @Input() displayReturn!: boolean;

  @Output() answer: EventEmitter<Answer> = new EventEmitter();
  @Output() return: EventEmitter<string | null> = new EventEmitter();

  clickAnswer(answer: Answer): void {
    this.answer.emit(answer);
  }

  clickReturn(trackEventLabel?: string): void {
    this.return.emit(trackEventLabel);
  }

  trackByAnswer(_: number, answer: Answer): string {
    return answer.value;
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [CejSimpleChoiceQuestionComponent],
  exports: [CejSimpleChoiceQuestionComponent],
})
export class CejSimpleChoiceQuestionModule {}
